export default __webpack_public_path__ + "static/media/img_pelatihan.5837be4c.webp";